var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppNavigationItem',{attrs:{"name":_vm.title},on:{"click":_vm.openUserSettings},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('AlertCircleIcon',{attrs:{"size":20}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }